import { render, staticRenderFns } from "./DeletePost.vue?vue&type=template&id=671218cb&scoped=true"
import script from "./DeletePost.vue?vue&type=script&lang=js"
export * from "./DeletePost.vue?vue&type=script&lang=js"
import style0 from "./DeletePost.vue?vue&type=style&index=0&id=671218cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671218cb",
  null
  
)

export default component.exports